import { combineEpics } from "redux-observable"
import { checkForDuplicateEmailEpic, checkForDuplicatePhoneNumberEpic, deleteEpic, fetchEpic, fetchSupplierEpic, patchEpic } from "./epics"

export const contactEpics = combineEpics(
    checkForDuplicateEmailEpic,
    checkForDuplicatePhoneNumberEpic,
    fetchEpic,
    patchEpic,
    deleteEpic,
    fetchSupplierEpic
)


// WEBPACK FOOTER //
// ./src/state/contact/epics/index.ts